<div class="row page-header no-print">
    <div class="col-12">
        <h1>Work Order Queue <small>Open work from Viewpoint and WebApps, ranked by priority</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row" style="margin-top: 20px">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                        <grid-export [grid]="queueGrid" [name]="'Work Order Queue'"></grid-export>
                        @if (canEdit) {
                            <button type="button" class="btn btn-primary btn-sm ms-2" (click)="openManualWorkOrder()">
                                New work order
                            </button>
                            <button
                                type="button"
                                class="btn btn-outline-danger btn-sm ms-2"
                                [disabled]="!canDeleteSelected"
                                (click)="deleteSelectedWorkOrder()"
                            >
                                Delete work order
                            </button>
                        }
                        <div class="input-header-group">
                            <span class="input-header">Mechanic</span>
                            <wj-combo-box
                                name="selectedMechanic"
                                [ngModel]="selectedMechanic()"
                                (ngModelChange)="selectedMechanic.set($event)"
                                [itemsSource]="mechanicsList"
                                [displayMemberPath]="'display'"
                                [selectedValuePath]="'value'"
                                [isRequired]="false"
                                [isDisabled]="mineOnly()"
                            >
                            </wj-combo-box>
                        </div>
                        <div class="input-header-group">
                            <span class="input-header">Equipment</span>
                            <wj-combo-box
                                name="historyEquipment"
                                [ngModel]="historyEquipment()"
                                (ngModelChange)="onHistoryEquipmentChanged($event)"
                                [itemsSource]="equipmentOptions"
                                [displayMemberPath]="'display'"
                                [selectedValuePath]="'value'"
                                [isRequired]="false"
                                [isEditable]="true"
                                [placeholder]="'Search or type equipment'"
                            >
                            </wj-combo-box>
                        </div>
                        @if (canUseMineOnly) {
                            <label class="form-check-label ms-3">
                                <input
                                    type="checkbox"
                                    class="form-check-input me-1"
                                    [ngModel]="mineOnly()"
                                    (ngModelChange)="onMineOnlyChanged($event)"
                                    name="mineOnly"
                                />
                                My queue only
                            </label>
                        }
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        #queueGrid
                        appAutoSize
                        [paddingControl]="'#wo-history-panel'"
                        [minHeight]="200"
                        (initialized)="grid.initialize(queueGrid)"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Work Order'" [binding]="'workOrderNumber'" [width]="110" [isReadOnly]="true">
                            <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                                <a href="javascript:void(0)" (click)="openWorkOrderDetails(cell.item)" class="wo-link">
                                    {{ cell.item.workOrderNumber }}
                                </a>
                            </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Queue #'"
                            [binding]="'queuePosition'"
                            [width]="90"
                            [isReadOnly]="true"
                        >
                            <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                                <span
                                    [class.wo-queue-vista]="cell.item.source === 'Vista'"
                                    [title]="cell.item.source === 'Vista' ? 'Calculated queue position; Vista work orders cannot be reordered here.' : null"
                                >
                                    {{ cell.item.queuePosition }}
                                </span>
                            </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Job Priority'"
                            [binding]="'jobPriority'"
                            [width]="90"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Equip Priority'"
                            [binding]="'equipmentPriority'"
                            [width]="95"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Equipment'"
                            [binding]="'equipmentDescription'"
                            [width]="'*'"
                            [isReadOnly]="true"
                        >
                            <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                                <a
                                    href="javascript:void(0)"
                                    (click)="setHistoryEquipment(cell.item.equipment, $event)"
                                    class="wo-link"
                                    [title]="'Show history for ' + cell.item.equipment"
                                >
                                    {{ cell.item.equipmentDescription }}
                                </a>
                            </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Job'" [binding]="'job'" [width]="90" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Description'"
                            [binding]="'description'"
                            [width]="'*'"
                            [isReadOnly]="true"
                        >
                            <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                                <a href="javascript:void(0)" (click)="openWorkOrderDetails(cell.item)" class="wo-link">
                                    {{ cell.item.description }}
                                </a>
                            </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'System'"
                            [binding]="'systemAffected'"
                            [width]="120"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Mechanic'"
                            [binding]="'mechanicName'"
                            [width]="160"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Status'"
                            [binding]="'status'"
                            [width]="100"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Created'"
                            [binding]="'dateCreated'"
                            [format]="'MM/dd/yyyy'"
                            [width]="100"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Due'"
                            [binding]="'dateDue'"
                            [format]="'MM/dd/yyyy'"
                            [width]="100"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
            <div id="wo-history-panel" class="row" style="padding-top: 24px">
                <div class="col-12">
                    <h2 class="h5">Work order history</h2>
                    <app-work-order-history
                        [equipment]="historyEquipment()"
                        (openWorkOrder)="openHistoryWorkOrder($event)"
                    ></app-work-order-history>
                </div>
            </div>
        </div>
    </div>
</div>
